import {observer} from "mobx-react-lite";
import {Fragment} from "react";
import {
    Button,
    ConfigProvider,
    Empty,
    Modal,
    Table,
} from "antd";
import {MyApplicationStore} from "../../../../store";

const {Column} = Table;


function ApplyPreview(props: any) {
    const submitPower = () => {
        MyApplicationStore.submitApplyNumber();
    };

    const tableEmptyRender = () => {
        return (
            <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={<>暂无数据</>}
            ></Empty>
        );
    };
    return (
        <Fragment>
            <Modal
                width={"50%"}
                title={"预览"}
                centered
                open={MyApplicationStore.applyPreviewModal}
                destroyOnClose={true}
                confirmLoading={MyApplicationStore.applyPreviewTableLoading}
                onCancel={() => MyApplicationStore.cancelApplyPreview()}
                footer={[
                    <Button
                        key="submit"
                        type="primary"
                        onClick={submitPower}
                        loading={MyApplicationStore.applyPreviewButtonLoading}
                    >
                        提交
                    </Button>,
                ]}
            >
                <ConfigProvider renderEmpty={tableEmptyRender}>
                    <Table
                        dataSource={MyApplicationStore.applyPreviewData.applicationDetails}
                        rowKey={(record: any) => record.order}
                        scroll={{ x: 700 ,y: 'calc(100vh - 345px)'}}
                        style={{marginTop:'20px'}}
                        pagination={false}
                    >
                        <Column width={120} ellipsis={true} title="序号" dataIndex="order"/>
                        <Column width={120} ellipsis={true} title="省" dataIndex="provinceName"/>
                        <Column width={120} ellipsis={true} title="市" dataIndex="cityName"/>
                        <Column width={120} title="所需号码数量" dataIndex="quantity"/>
                    </Table></ConfigProvider>
            </Modal>
        </Fragment>
    );
}

export default observer(ApplyPreview);
